export default "__VITE_ASSET__e97d9d3a__"